import { Entry } from 'contentful'
import { format } from 'date-fns'
import { utcToZonedTime } from 'date-fns-tz'

interface EntryType extends Queries.ContentfulEntry {
  __typename?: string
}

export function isContentfulType<T extends EntryType>(
  item: {
    __typename?: string
    // biome-ignore lint/suspicious/noExplicitAny: <explanation>
  } & Entry<any>,
  name: string,
): item is T & {
  __typename?: string
  // biome-ignore lint/suspicious/noExplicitAny: <explanation>
} & Entry<any> {
  return item && item.__typename === name
}

export const contentfulConfig = {
  spaceId: process.env.GATSBY_CONTENTFUL_SPACE_ID,
  accessToken: process.env.GATSBY_CONTENTFUL_PREVIEW_TOKEN
    ? process.env.GATSBY_CONTENTFUL_PREVIEW_TOKEN
    : process.env.GATSBY_CONTENTFUL_ACCESS_TOKEN,
  host: process.env.GATSBY_CONTENTFUL_PREVIEW_TOKEN
    ? 'preview.contentful.com'
    : 'cdn.contentful.com',
  environment: process.env.GATSBY_CONTENTFUL_ENVIRONMENT
    ? process.env.GATSBY_CONTENTFUL_ENVIRONMENT
    : 'master',
}

export const { spaceId, accessToken, host, environment } = contentfulConfig

export const contentfulGraphQLUrl = `https://graphql.contentful.com/content/v1/spaces/${spaceId}/environments/${environment}`

// get current date time in new zealand
export const currentDateTime = (): string => {
  const now = new Date()
  const nzDate = utcToZonedTime(now, 'Pacific/Auckland')
  return format(nzDate, "yyyy-MM-dd'T'HH:mm:ss.SSSxxx")
}

// get current utc date time without timezone
export const currentUtcDateTime = (): string => {
  const now = new Date()
  return format(now, "yyyy-MM-dd'T'HH:mm:ss.SSS")
}

/**
 * Clear path to redirect from, ensuring it has a trailing slash
 *
 * @param path
 * @param isPermanent
 */
export const cleanFromPath = (
  path: string | undefined | null,
  isPermanent = true,
): string => {
  if (!path) {
    return ''
  }

  // Ignore home page
  if (path === '/') {
    return path
  }

  // Permanant redirects always have a trailing slash
  if (isPermanent) {
    return `${path.replace(/\/?$/, '/')}`
  }

  // Temporary redirects never have a trailing slash
  return `${path.replace(/\/?$/, '')}`
}
